import { RevealWrapper } from '../components/RevealWrapper'
import { FAQItem } from '../components/FAQItem'

const FAQS = [
  {
    q: 'Funciona sem internet no campo?',
    a: 'Sim. As informações essenciais ficam disponíveis offline. Assim que você conectar de volta, tudo sincroniza automaticamente.',
  },
  {
    q: 'Tenho só 1 drone. Vale a pena?',
    a: 'Completamente. O DroneOps foi desenhado para operadores solo. Financeiro, agenda e clientes — tudo que você precisa, sem complexidade desnecessária.',
  },
  {
    q: 'É difícil de configurar?',
    a: 'Menos de 10 minutos para cadastrar seus dados básicos e já começar a operar. Nenhum treinamento técnico necessário.',
  },
  {
    q: 'Tem contrato de fidelidade?',
    a: 'Não. Você assina mês a mês. Simples assim.',
  },
  {
    q: 'Meus dados ficam seguros?',
    a: 'Sim. Toda a infraestrutura roda na Supabase com criptografia e backups automáticos diários. Seus dados são exclusivamente seus.',
  },
]

export function FAQSection() {
  return (
    <section
      aria-labelledby="faq-heading"
      style={{ padding: '0 24px 72px', maxWidth: 480, margin: '0 auto' }}
    >
      <RevealWrapper>
        <h2
          id="faq-heading"
          style={{
            fontFamily: 'var(--font-bricolage)',
            fontSize: 'clamp(22px, 6vw, 26px)',
            fontWeight: 800,
            lineHeight: 1.2,
            letterSpacing: '-0.025em',
            marginBottom: 28,
          }}
        >
          Dúvidas frequentes
        </h2>
      </RevealWrapper>

      <div style={{ borderTop: '1px solid #E9E5DC' }}>
        {FAQS.map((faq, i) => (
          <FAQItem key={i} question={faq.q} answer={faq.a} />
        ))}
      </div>
    </section>
  )
}
